import VTTimelineItem from "@virtus-tech-repository/virtus-tech-repository/lib/components/VTTimelineItem";

import { EDraggableOptions } from "@virtus-tech-repository/virtus-tech-repository/lib/models/media.model";
import { IScene } from "@virtus-tech-repository/virtus-tech-repository/lib/models/scenario.model";

import NoPreview from "../../../assets/images/NoScenarioImage.svg";
import NoPreviewFile from "../../../assets/images/NoFilesImage.svg";
import { Node, NodeProps } from "@xyflow/react";
import { getImageForSceneOrDefaultImageIfPreviewImageDoesntExist } from "../../../utils/getImageForSceneOrDefaultImageIfPreviewImageDoesntExist";
import { IHotspot } from "@virtus-tech-repository/virtus-tech-repository/lib/models/hotspot.model";
import { VTHTMLHotspot } from "@virtus-tech-repository/virtus-tech-repository";
import { IconSwitch } from "../../../helpers/IconSwitchHelper";
import { useEffect } from "react";

type NodeData = {
    hoyspot: IHotspot;
};

type CustomNode = Node<NodeData>;

export default function VTNodeHotspot({ data }: NodeProps<CustomNode>) {
    return (
        <>
            {data.hoyspot && (
                <VTHTMLHotspot
                    onClose={undefined}
                    scale2d={
                        data.hoyspot.styles?.postClickStyles?.scale
                            ? data.hoyspot.styles?.postClickStyles?.scale * 0.65
                            : 0.65
                    }
                    sx={{
                        "> div:nth-child(1) > div": {
                            border: `3px solid ${
                                data.hoyspot.styles?.preClickStyles?.colours?.border &&
                                `rgba(${data.hoyspot.styles?.preClickStyles?.colours?.border.r}, ${data.hoyspot.styles?.preClickStyles?.colours?.border.g}, ${data.hoyspot.styles?.preClickStyles?.colours?.border.b}, ${data.hoyspot.styles?.preClickStyles?.colours?.border.a})`
                            }`,
                            background: `${
                                data.hoyspot.styles?.preClickStyles?.colours?.background
                                    ? `rgba(${data.hoyspot.styles?.preClickStyles?.colours?.background.r}, ${data.hoyspot.styles?.preClickStyles?.colours?.background.g}, ${data.hoyspot.styles?.preClickStyles?.colours?.background.b}, ${data.hoyspot.styles?.preClickStyles?.colours?.background.a})`
                                    : "rgba(30,30,30,0.5)"
                            } `,
                            h3: {
                                color: `${
                                    data.hoyspot.styles?.preClickStyles?.colours?.text
                                        ? `rgba(${data.hoyspot.styles?.preClickStyles?.colours?.text.r}, ${data.hoyspot.styles?.preClickStyles?.colours?.text.g}, ${data.hoyspot.styles?.preClickStyles?.colours?.text.b}, ${data.hoyspot.styles?.preClickStyles?.colours?.text.a})`
                                        : "#fff"
                                } !important`,
                            },
                        },
                        "> div:nth-child(2) > div": {
                            background: `${
                                data.hoyspot.styles?.preClickStyles?.colours?.background
                                    ? `rgba(${data.hoyspot.styles?.preClickStyles?.colours?.background.r}, ${data.hoyspot.styles?.preClickStyles?.colours?.background.g}, ${data.hoyspot.styles?.preClickStyles?.colours?.background.b}, ${data.hoyspot.styles?.preClickStyles?.colours?.background.a})`
                                    : "rgba(30,30,30,0.5)"
                            } `,
                            border: `3px solid ${
                                data.hoyspot.styles?.preClickStyles?.colours?.border &&
                                `rgba(${data.hoyspot.styles?.preClickStyles?.colours?.border.r}, ${data.hoyspot.styles?.preClickStyles?.colours?.border.g}, ${data.hoyspot.styles?.preClickStyles?.colours?.border.b}, ${data.hoyspot.styles?.preClickStyles?.colours?.border.a})`
                            }`,
                            div: {
                                color: `${
                                    data.hoyspot.styles?.preClickStyles?.colours?.text
                                        ? `rgba(${data.hoyspot.styles?.preClickStyles?.colours?.text.r}, ${data.hoyspot.styles?.preClickStyles?.colours?.text.g}, ${data.hoyspot.styles?.preClickStyles?.colours?.text.b}, ${data.hoyspot.styles?.preClickStyles?.colours?.text.a})`
                                        : "#fff"
                                }`,
                            },
                        },
                    }}
                    title={data.hoyspot.contents.preClickContent.title}
                    icon={IconSwitch(data.hoyspot.contents.preClickContent.icon)}
                    vtRichTextEditorContent={
                        data.hoyspot.contents.preClickContent.contentData &&
                        typeof data.hoyspot.contents.preClickContent.contentData === "string" &&
                        data.hoyspot.contents.preClickContent.contentData.replace(/\s+/g, "") !==
                            `<divclass="rte-container"></div>`
                            ? {
                                  content: data.hoyspot.contents.preClickContent.contentData,
                              }
                            : undefined
                    }
                />
            )}
        </>
    );
}
